import { useTranslation } from "react-i18next";
import { IcoSwap } from "src/assets";

interface CashbackButtonProps {
  onClick: () => void;
}

export default function CashbackButton({ onClick }: CashbackButtonProps) {
  const { t } = useTranslation();
  return (
    <div
      className="relative flex h-12 max-h-[50px] w-full grow cursor-pointer items-center justify-center rounded-lg border  border-[rgba(255,255,255,0.24)]  py-2 px-2 text-sm font-bold uppercase leading-6 text-white transition-colors
        hover:!bg-[radial-gradient(circle_at_50%_14.81%,#96e24e_0%,#48890A_100%)]
        active:!bg-[radial-gradient(circle_at_50%_14.81%,#90af72_0%,#48890A_100%)]
      "
      style={{
        background: "radial-gradient(circle at 50% 14.81%, #81D233 0%, #48890A 100%)",
        boxShadow:
          "0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 20px 0px rgba(129, 210, 51, 0.56), 0px 4px 12px 0px rgba(255, 255, 255, 0.20) inset",
      }}
      onClick={onClick}
    >
      <div
        className="absolute top-0 left-0 h-14 w-14 translate-x-3 translate-y-[-50%] animate-[slow-shining_10s_linear_infinite]"
        style={{
          background: "url(/images/icon/shining1.png)",
        }}
      ></div>
      <div className="flex flex-row items-center gap-2">
        <IcoSwap className="hidden h-5 w-5 min-[360px]:block" />
        <div className="">{t("cashBack")}</div>
      </div>
    </div>
  );
}
